export default __webpack_public_path__ + "static/fournaise-au-bois-26f1695cb12c5de9f5fb2fdf82260dce.jpg";